import PropTypes from 'prop-types';
import SearchResultGroupImpl from './search-result-group.js';
import MojitoCore from 'mojito/core';
import { noop } from 'mojito/utils';

const { UIView } = MojitoCore.Presentation;

/**
 * Display the group of search result. Ex: Events, Competitions, Race meetings etc.
 *
 * @class SearchResultGroup
 * @memberof Mojito.Applications.Sports.Search
 */

/**
 * SearchResultGroup prop types.
 *
 * @property {Array<object>} searchResult - Search result items.
 * @property {string} title - Group title.
 * @property {Function} [onRedirection = ()=>{}] - Search result item clicked callback.
 * @property {boolean} [isPlayerGroup] - Whether a player group or not.
 * @memberof Mojito.Applications.Sports.Search.SearchResultGroup
 */

const propTypes = {
    searchResult: PropTypes.array.isRequired,
    title: PropTypes.string.isRequired,
    onRedirection: PropTypes.func,
    isPlayerGroup: PropTypes.bool,
};

const defaultProps = {
    searchResult: [],
    onRedirection: noop,
};

export default UIView('SearchResultGroup', SearchResultGroupImpl, propTypes, defaultProps);
